import React, { Component } from 'react';
import Loader from '../loader/loader.jsx'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Recaptcha from 'react-recaptcha'
import GusetNavbar from '../navigation/guestnavbar.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import creditcardlogo from '../../images/credit-cards-vector-icon-.jpg'
import { connect } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import answerimg from '../../images/answer.png'
import {
    Step,
    Stepper,
    StepLabel,
} from 'material-ui/Stepper';
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import * as actions from '../../actions/actions.jsx'
import s from '../../services/allservices.jsx'
const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
    ({
        userIdState: state.getuseridReducer.userIdState,
        cardNumber: state.stoteCardDetail.cardNumber,
        publicKey: state.publicKey.publicKey
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchUserid(cardNumber) {
            dispatch(
                actions.getUseridAction(cardNumber)
            )
        }
    })
var callback = function () {

};

// specifying verify callback function
var verifyCallback = function (response) {

};
let recaptchaInstance;
const resetRecaptcha=()=>{
    recaptchaInstance.reset()
}
const JSEncrypt = window.JSEncrypt
class ForgotUserId extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepIndex: 0,
            response: "",
            cardNumber: '',
            secretQuestionAnswer: '',
            secretQuestionCode: '',
            secretQuestionDescription: '',
            emailId: '',
            mobileNumber: '',
            secretPassword: '',
            accountId: '',
            applicationId: '',
            disabled: true,
            disableduser:true
        }
    }


    handleGoback(e) {
        localStorage.clear();
        this.props.history.push("/logout")
    }
    onChange = (e, value) => this.setState({ [e.target.name]: value }, () => {
        if (this.state.cardNumber.length !== 0) {
            this.setState({
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
    })

    handleAnswer = (e, value) => this.setState({ [e.target.name]: value }, () => {
        if (this.state.secretPassword.length !== 0) {
            this.setState({
                disableduser: false
            })
        }
        else {
            console
            this.setState({
                disableduser: true
            })
        }
    })

    verifyCallback = response => {
        this.setState({
            response: response
        })
    }
    handelSecretAnswer = () => {

        const { response } = this.state
        const { publicKey } = this.props
   
        let _this = this
        if (response !== '') {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                const state = {
                    applicationId: "gmcabs",
                    secretPassword: encrypt.encrypt(this.state.secretPassword),
                    accountId: encrypt.encrypt(this.state.accountId),
                    secretQuestionCode: encrypt.encrypt(this.state.secretQuestionCode),
                }
                fetch(s.send_userid + "/?g-recaptcha-response=" + response, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify(state)
                })

                    .then(res => {
                        if (res.status === 200 || res.status === 204) {
                         
                            toast.success(res.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            setTimeout(function () {
                                _this.props.history.push('/logout');
                            }, 3000);
                        } else {
                            toast.error(res.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            resetRecaptcha()
                            document.getElementById("secretAnswer").value=""
                            document.getElementById("secretAnswer").focus()
                     
                        }
                    })
            }
        }
    }
    checkUserId = () => {
        const { publicKey } = this.props
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);
            const state = {
                applicationId: "gmcabs",
                cardNumber: encrypt.encrypt(this.state.cardNumber),
            }
            fetch(s.get_userid, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify(state)
            })
                .then(res => {
                    if (res.status === 200 || res.status === 201) {
                        res.json().then(json => {
                            
                            this.setState({
                                stepIndex: 1,
                                secretQuestionCode: json.secretQuestionCode,
                                secretQuestionDescription: json.secretQuestionDescription,
                                accountId: json.accountId,
                                emailId: json.emailId
                            }, () => {
                               
                            });
                        })
                    }else{
                    toast.error(res.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
                })
        }
    }
    getStepContent(stepIndex) {
        const { userIdState } = this.props
        const { cardNumber, secretQuestionDescription, emailId } = this.state
        switch (stepIndex) {
            case 0:
                return (
                    <div>
                        <ToastContainer
                            draggablePercent={60}
                            position="top-right"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnVisibilityChange
                            draggable={false}
                            pauseOnHover
                        />

                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="col-md-12" >
                                        <div className="row box-shadow-style" style={{ padding: "12px 15px", minHeight: "100px" }} >
                                            <div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <h4>Forgot Your User ID?</h4>
                                                    </div>

                                                    <div className="col-md-12" style={{ fontSize: "13px" }}>
                                                        <span>Here you can retrieve your user ID</span>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12" style={{ padding: "0px 15px", marginTop: "20px" }}>
                                        <div className="row box-shadow-style" style={{ padding: "12px 15px", minHeight: "300px" }} >
                                            <div className="summary-header">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <p>Please Enter Your Card Number</p>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="row" >
                                                            <div className="row input-group" >
                                                                <div className="offset-md-1 col-sm-2 input-icon" >
                                                                    <img src={creditcardlogo} alt="" />
                                                                </div>
                                                                <div className="col-sm-9" >
                                                                    <TextField
                                                                        hintText="Card Number"
                                                                        floatingLabelText="Card Number"
                                                                        type="text"
                                                                        name="cardNumber"
                                                                        maxLength="16"
                                                                        className="my-className"
                                                                        onChange={this.onChange}
                                                                        underlineFocusStyle={styles.focusStyle}
                                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="row input-group"  >

                                                                <div className="offset-md-2 col-sm-4 nopadding" style={{ marginTop: '20px' }} >
                                                                    <RaisedButton
                                                                        label="Go Back To HomePage"
                                                                        // style={styles.button}
                                                                        backgroundColor="#333"
                                                                        labelColor="#fff"
                                                                        onClick={this.handleGoback.bind(this)}
                                                                        icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                    />
                                                                </div>
                                                                <div className="col-sm-3" style={{ marginTop: '20px' }} >
                                                                    <RaisedButton
                                                                        label="Continue"
                                                                        // style={styles.button}
                                                                        backgroundColor="#333"
                                                                        disabled={this.state.disabled}
                                                                        labelColor="#fff"
                                                                        onClick={this.checkUserId}
                                                                        icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                    />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 1:
                return (
                    <div>
                        <ToastContainer
                            draggablePercent={60}
                            position="top-right"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnVisibilityChange
                            draggable={false}
                            pauseOnHover
                        />
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="col-sm-12">
                                        <div className="col-md-12">
                                            <div className="row box-shadow-style" style={{ padding: "12px 15px", minHeight: "100px" }} >
                                                <div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <p>Forgot Your User ID?</p>
                                                        </div>

                                                        <div className="col-md-12" style={{ fontSize: "13px" }}>
                                                            <span>Complete the following security question to retrieve your User ID. </span>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ padding: "0px 15px", marginTop: "20px" }}>
                                            <div className="row box-shadow-style" style={{ padding: "12px 15px", minHeight: "100px" }} >
                                                <div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <p>Please answer your secret question for verification.</p>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="offset-md-1 col-md-10">
                                                                    <label className="col-md-4 ">Secret Question: </label>
                                                                    <span className="col-md-6 nopadding" style={{marginLeft:"-20px"}}>{secretQuestionDescription +"?"} </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="row" >
                                                                <div className="row input-group" >
                                                                    <div className="offset-md-1 col-2 input-icon" >
                                                                        <img src={answerimg} alt="" />
                                                                    </div>
                                                                    <div className="col-sm-9" >
                                                                        <TextField
                                                                            hintText="Answer for Secret Question"
                                                                            floatingLabelText="Secret Answer"
                                                                            type="text"
                                                                            id="secretAnswer"
                                                                            name="secretPassword"
                                                                            maxLength="50"
                                                                            className="my-className"
                                                                            onChange={this.handleAnswer}
                                                                            underlineFocusStyle={styles.focusStyle}
                                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="offset-md-5 col-sm-7 text-center margin-capcha">
                                                                        <Recaptcha
                                                                            sitekey="6LeRorofAAAAACriDJ7aN2WI9LOCRz8aN2KzqU3C"
                                                                            render="explicit"
                                                                            verifyCallback={this.verifyCallback}
                                                                            onloadCallback={callback}
                                                                            ref={e => recaptchaInstance=e}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row input-group" style={{ marginTop: "15px" }} >
                                                                    <div className="col-sm-12 " style={{ marginLeft: "145px" }}>
                                                                        <label style={{ fontSize: "15px", color: "rgb(66, 62, 62)" }}>
                                                                        User ID to be emailed to:  {emailId}
                                                                        </label>
                                                                    </div>

                                                                </div>
                                                                <div className="row input-group"  >

                                                                    <div className="offset-md-2 col-sm-5 " style={{ marginTop: '20px', marginRight: '5px' }} >
                                                                        <RaisedButton
                                                                            label="Go Back To HomePage"
                                                                            // style={styles.button}
                                                                            backgroundColor="#333"
                                                                            labelColor="#fff"
                                                                            onClick={this.handleGoback.bind(this)}
                                                                            icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                        />
                                                                    </div>
                                                                    <div className="col-sm-3 nopadding" style={{ marginTop: '20px', marginLeft: "-25px" }} >
                                                                        <RaisedButton
                                                                            label="Get User ID"
                                                                            // style={styles.button}
                                                                            backgroundColor="#333"
                                                                            labelColor="#fff"
                                                                            onClick={this.handelSecretAnswer}
                                                                            disabled={this.state.disableduser}
                                                                            icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                        />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div>Something Went Wrong</div>
                )
        }
    }

    sendUserDetail(userDetail) {
        this.setState({ stepIndex: 1, userDetailState: userDetail });
    }
    handleNext() {

        const { stepIndex } = this.state;

        if (stepIndex < 2) {
            this.setState({ stepIndex: stepIndex + 1 });
        }
    }

    handlePrev() {
        const { stepIndex } = this.state;

        if (stepIndex > 0) {
            this.setState({ stepIndex: stepIndex - 1 });
        }
    }
    handleStep1() {
        this.setState({ stepIndex: 2 });
    }

    render() {
        const { stepIndex } = this.state;

        return (
            <div>
                <div><GusetNavbar /> </div>
                <div style={{ width: '100%', maxWidth: 700, margin: 'auto', marginTop: "80px" }}>
                    <Stepper activeStep={stepIndex} connector={<ArrowForwardIcon />}>
                        <Step className="step">
                            <StepLabel>Forgot User Id</StepLabel>
                        </Step>

                        <Step className="step">
                            <StepLabel>Verify & Submit</StepLabel>
                        </Step>
                    </Stepper>

                    {this.getStepContent(stepIndex)}


                </div>
            </div>
        );
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ForgotUserId);



// WEBPACK FOOTER //
// ./src/components/forgotuserId/forgotUserId.jsx